import { Navigate, useParams } from "react-router";

/** Alte Adressen der Website-Termine (bis 14.10.2026): Sie heißen jetzt Veranstaltungen (BAUPLAN-PAKETE.md, Abschnitt 5.3). */
export function ZuVeranstaltungen() {
  return <Navigate to="/redaktion/veranstaltungen" replace />;
}

export function ZuVeranstaltung() {
  const { slug = "" } = useParams();
  return <Navigate to={`/redaktion/veranstaltungen/${encodeURIComponent(slug)}`} replace />;
}
